export default "/_next/static/assets/images/hearken-placeholder-desktop.cea61cdaae3ec64f3cad0683a70e045b.png";